import { IMentorTopic } from 'app/shared/model/mentor-topic.model';
import { IMenteeTopic } from 'app/shared/model/mentee-topic.model';
import { IMeeting } from 'app/shared/model/meeting.model';

export interface ITopic {
  id?: number;
  name?: string;
  parentId?: number | null;
  mentorTopics?: IMentorTopic[] | null;
  menteeTopics?: IMenteeTopic[] | null;
  meetings?: IMeeting[] | null;
}

export const defaultValue: Readonly<ITopic> = {};
